import React from 'react';
import { NavLink } from 'react-router-dom';
import '../App.css'; // Ensure CSS is available

const Navbar = ({ t, sidebarOpen, setSidebarOpen }) => {
    return (
        <>
            <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
                <div className="sidebar-header">
                    <h2>F1 2026</h2>
                    <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
                </div>
                <nav className="sidebar-nav">
                    <NavLink
                        to="/"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                        end
                    >
                        <span className="nav-text">{t.navCalendar}</span>
                    </NavLink>
                    <NavLink
                        to="/standings"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        <span className="nav-text">{t.navStandings}</span>
                    </NavLink>
                    <NavLink
                        to="/points"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        <span className="nav-text">{t.navPoints}</span>
                    </NavLink>
                    <NavLink
                        to="/teams"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        <span className="nav-text">{t.navTeams}</span>
                    </NavLink>
                    <NavLink
                        to="/simulator"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        <span className="nav-text">{t.navSimulator}</span>
                    </NavLink>
                </nav>
            </aside>
            {/* OVERLAY FOR MOBILE */}
            {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}
        </>
    );
};

export default Navbar;
